import { Row } from '@tanstack/react-table';
import { ToDoRowModel } from '../entities/Entities';
import { Konflikt } from '../entities/Konflikt';

export function sortDauer(
  rowA: Row<ToDoRowModel>,
  rowB: Row<ToDoRowModel>,
): number {
  let dauerA = 0;
  let dauerB = 0;

  if (rowA.original instanceof Konflikt) {
    dauerA = rowA.original.rootArbeitszeit.dauer ?? 0;
  } else {
    dauerA = rowA.original.dauer ?? 0;
  }

  if (rowB.original instanceof Konflikt) {
    dauerB = rowB.original.rootArbeitszeit.dauer ?? 0;
  } else {
    dauerB = rowB.original.dauer ?? 0;
  }

  if (dauerA < dauerB) {
    return -1;
  }
  if (dauerA > dauerB) {
    return 1;
  }
  return 0;
}
